/**
 * Angular imports.
 */
import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * This component is used to show the content.
 */
@Component({
  selector: 'pap-see-more',
  templateUrl: './see-more.component.html',
  styleUrls: ['./see-more.component.scss']
})
export class SeeMoreComponent implements OnInit {
  /**
   * Receive content data.
   */
  @Input() contentData: string;

  /**
   * Receive the no. of char to show.
   */
  @Input() showChar: number;

  /**
   * Flag for see more/ see less.
   */
  public seeMoreFlag = false;

  /**
   * Hold content data.
   */
  public content: string;

  constructor( public translate: TranslateService){}

  /**
   * Check flag for see more/ see less.
   */
  ngOnInit(): void {
    this.content = this.contentData;
    if (this.contentData?.length > this.showChar) {
      this.seeMoreFlag = true;
    }
  }

  /**
   * See more / see less logic.
   */
  SeeMore(): void {
    this.seeMoreFlag = !this.seeMoreFlag;
    if (this.seeMoreFlag) {
      this.content = this.contentData;
    }
  }
}
